import { useEffect } from 'react';
import { connect } from 'react-redux';
import { clearAgendaFilterAndScroll } from '@/redux/actions';

// separate from AgendaSubscriptions so filter/scroll does not depend on the websocket wiring
const AgendaFilterScope = ({ children, clearAgendaFilterAndScroll }) => {
	useEffect(() => () => clearAgendaFilterAndScroll('AgendaFilterScope.unmount'), []);

	return children;
};

const mdp = dispatch => ({
	clearAgendaFilterAndScroll: from => dispatch(clearAgendaFilterAndScroll(from)),
});

export default connect(null, mdp)(AgendaFilterScope);
